import * as Tooltip from '@radix-ui/react-tooltip';
import { Info } from 'lucide-react';
import type { ReactNode } from 'react';
import styles from './InfoTooltip.module.css';

interface InfoTooltipProps {
  label: string;
  children: ReactNode;
}

export const InfoTooltip = ({ label, children }: InfoTooltipProps) => (
  <Tooltip.Provider delayDuration={100}>
    <Tooltip.Root>
      <Tooltip.Trigger asChild>
        <button type="button" className={styles.trigger} aria-label={label}>
          <Info className="h-3.5 w-3.5" />
        </button>
      </Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content side="top" sideOffset={6} className={styles.content}>
          {children}
          <Tooltip.Arrow className={styles.arrow} />
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  </Tooltip.Provider>
);
